import React from 'react';
import { LoadingSpin } from 'common/components/LoadingSpin';
import { useAppSelector } from 'app/store/store.hooks';
import { EUserRole } from 'entities/User/User.models';

interface IComponentProps {
  franchisorRoutes: React.ReactElement;
  franchiseeRoutes: React.ReactElement;
  salesOpsRoutes: React.ReactElement;
}
export const RoleCheckLayout: React.FC<IComponentProps> = ({ franchisorRoutes, franchiseeRoutes, salesOpsRoutes }) => {
  const { authModel, authUser, authUserLoading } = useAppSelector((state) => state.auth);

  const getRoutesByRole = () => {
    switch (authUser?.role) {
      case EUserRole.Franchisee:
        return franchiseeRoutes;
      case EUserRole.SalesOps:
        return salesOpsRoutes;
      case EUserRole.Franchisor:
      default:
        return franchisorRoutes;
    }
  };

  // `authModel.access` means we're authorized, but role + permissions live on `authUser`
  // (GET /users/:id). Between `setAuthModel` and the authUser fetch there is a render tick where
  // `authUser` is still null — without this guard `getRoutesByRole` falls through to the default
  // (franchisor) admin routes for a franchisee/salesOps user, briefly mounting pages that fire
  // module-guarded requests (GET /permissions/profiles, GET /users) and get 403 before the app
  // redirects them to their real module.
  const isAuthUserPending = Boolean(authModel?.access) && !authUser;

  return authUserLoading || isAuthUserPending ? <LoadingSpin /> : getRoutesByRole();
};
